module.exports = __webpack_public_path__ + "static/img/pop.a9a8585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pop.png
// module id = 1HL7
// module chunks = 1